import api, { endpoints } from '@/utils/api';

export const fetchReceivedRequests = async (userId, params = {}) => {
  try {
    const response = await api.get(`${endpoints.receivedRequests}/${userId}`, {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching received requests:', error);
    throw error;
  }
};

export const fetchSentRequests = async (userId, params = {}) => {
  try {
    const response = await api.get(`${endpoints.sentRequests}/${userId}/sent`, {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sent requests:', error);
    throw error;
  }
};

export const fetchGeneralConnections = async (userId, params = {}) => {
  try {
    const response = await api.get(`${endpoints.generalConnections}/${userId}/general`, {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching general connections:', error);
    throw error;
  }
};

export const createConnectionRequest = async (requestData) => {
  try {
    const response = await api.post(endpoints.connectionRequests, requestData);
    return response.data;
  } catch (error) {
    console.error('Error creating connection request:', error);
    throw error;
  }
};

export const acceptConnectionRequest = async (requestId) => {
  try {
    const response = await api.patch(`${endpoints.acceptRequest}/${requestId}/accept`);
    return response.data;
  } catch (error) {
    console.error('Error accepting connection request:', error);
    throw error;
  }
};

export const rejectConnectionRequest = async (requestId) => {
  try {
    const response = await api.put(`${endpoints.rejectRequest}/${requestId}`, { status: 'rejected' });
    return response.data;
  } catch (error) {
    console.error('Error rejecting connection request:', error);
    throw error;
  }
};

export default {
  fetchReceivedRequests,
  fetchSentRequests,
  fetchGeneralConnections,
  createConnectionRequest,
  acceptConnectionRequest,
  rejectConnectionRequest,
};